<div class="boris">

  <section class="boris-hero">
    <img class="boris-hero__avatar" src="assets/boris.png" alt="Boris">
    <div class="boris-hero__main">
      <h1 class="stk-page-title">Boris <span class="boris-hero__tag">3D-tervező</span></h1>
      <div class="stk-page-sub">Küldj neki vázlatot, render képet vagy STL-t a chatben, és beszéljétek meg az új termékcsaládot. A modellezést a tervezőgépen végzi (Blender, Meshy, Bambu Studio), és a rendereket meg a nyomtatható fájlt visszaküldi a chatbe.</div>
      <div class="boris-hero__status" *ngIf="data">
        <span class="stk-pill" [ngClass]="data.enabled && data.workerOnline ? 'stk-pill--green' : 'stk-pill--yellow'">{{ workerLabel }}</span>
        <span class="boris-hero__seen" *ngIf="data.workerSeenAt && !data.workerOnline">utoljára: {{ data.workerSeenAt | date:'MMM d., HH:mm' }}</span>
        <label class="boris-switch" [title]="data.enabled ? 'Kikapcsolás' : 'Bekapcsolás'">
          <input type="checkbox" [checked]="data.enabled" (change)="toggleEnabled()">
          <span></span>
        </label>
      </div>
    </div>
    <a class="stk-btn stk-btn--accent boris-hero__cta" *ngIf="chatLink" [routerLink]="chatLink">Írj Borisnak 💬</a>
  </section>

  <div class="boris-empty" *ngIf="loading && !data">Betöltés…</div>
  <div class="boris-empty" *ngIf="loadFailed">Boris adatai most nem érhetők el.</div>

  <ng-container *ngIf="data">
    <section class="boris-card boris-card--proposals" *ngIf="data.proposals.length">
      <h2 class="stk-section-title">Boris javasolja, hogy jegyezze meg <span class="boris-count">{{ data.proposals.length }}</span></h2>
      <div class="boris-help">Ezek akkor kerülnek a tudástárba, ha jóváhagyod. Előtte átírhatod őket.</div>
      <div class="boris-item" *ngFor="let p of data.proposals">
        <ng-container *ngIf="editing[p.id] === undefined; else editProposal">
          <div class="boris-item__text">{{ p.text }}</div>
          <div class="boris-item__actions">
            <button type="button" class="stk-btn stk-btn--accent boris-btn" [disabled]="saving" (click)="save(p.id, true)">Jóváhagyom</button>
            <button type="button" class="stk-btn stk-btn--ghost boris-btn" (click)="startEdit(p)">Átírom</button>
            <button type="button" class="stk-icon-btn" title="Elvetem" (click)="remove(p.id, 'Elveted Boris javaslatát?')">✕</button>
          </div>
        </ng-container>
        <ng-template #editProposal>
          <textarea class="boris-textarea" rows="3" [(ngModel)]="editing[p.id]"></textarea>
          <div class="boris-item__actions">
            <button type="button" class="stk-btn stk-btn--accent boris-btn" [disabled]="saving" (click)="save(p.id, true)">Mentés és jóváhagyás</button>
            <button type="button" class="stk-btn stk-btn--ghost boris-btn" (click)="cancelEdit(p.id)">Mégse</button>
          </div>
        </ng-template>
      </div>
    </section>

    <section class="boris-card">
      <h2 class="stk-section-title">Tervezési feladatok <span class="boris-count">{{ openTasks.length }}</span></h2>
      <div class="boris-help">Amit Farmy (a gyártásmérnök) Borisra bízott — pl. egyedi névtáblák. Boris ebben a sorrendben dolgozik rajtuk (a chat-üzenetek mindig előbb jönnek); ha kész, a fájlokkal visszaadja Farmynak, aki gyártásba teszi.</div>
      <div class="boris-help" *ngIf="!tasks.length">Még nincs tervezési feladat.</div>
      <div class="boris-task" *ngFor="let t of openTasks; let i = index; let last = last">
        <div class="boris-task__top">
          <span class="boris-task__no">#T-{{ t.id }}</span>
          <span class="boris-job__status boris-job__status--{{ t.status }}">{{ taskStatusLabel[t.status] }}</span>
          <span class="boris-job__who">{{ t.from }}<ng-container *ngIf="t.requestedBy"> · kérte: {{ t.requestedBy }}</ng-container></span>
          <span class="boris-job__when">{{ t.createdAt | date:'MMM d., HH:mm' }}</span>
        </div>
        <div class="boris-item__text">{{ t.instruction }}</div>
        <div class="boris-item__actions">
          <button type="button" class="stk-icon-btn" title="Előrébb" [disabled]="i === 0" (click)="moveTask(t, 'up')">▲</button>
          <button type="button" class="stk-icon-btn" title="Hátrébb" [disabled]="last" (click)="moveTask(t, 'down')">▼</button>
          <a class="stk-btn stk-btn--ghost boris-btn" *ngIf="taskChatLink" [routerLink]="taskChatLink">Beszélgetés</a>
          <button type="button" class="stk-icon-btn" title="Törlés a sorból" (click)="cancelTask(t)">✕</button>
        </div>
      </div>
      <div class="boris-task boris-task--closed" *ngFor="let t of closedTasks" (click)="expanded[-t.id] = !expanded[-t.id]">
        <div class="boris-task__top">
          <span class="boris-task__no">#T-{{ t.id }}</span>
          <span class="boris-job__status boris-job__status--{{ t.status }}">{{ taskStatusLabel[t.status] }}</span>
          <span class="boris-job__who">{{ t.instruction | slice:0:80 }}{{ t.instruction.length > 80 ? '…' : '' }}</span>
          <span class="boris-job__when">{{ (t.finishedAt || t.createdAt) | date:'MMM d., HH:mm' }}</span>
        </div>
        <div class="boris-job__text" *ngIf="expanded[-t.id]">{{ t.result || '—' }}<ng-container *ngIf="t.files.length"><br>Fájlok: {{ t.files.join(', ') }}</ng-container></div>
      </div>
    </section>

    <section class="boris-card">
      <h2 class="stk-section-title">Tudástár <span class="boris-count">{{ data.knowledge.length }}</span></h2>
      <div class="boris-help">Amit itt leírsz, azt Boris minden beszélgetésben figyelembe veszi: a terráriumok méretei, a mágnesek, a nyomtató, a tiltások. Egy bejegyzés legyen egy téma.</div>

      <div class="boris-add">
        <textarea class="boris-textarea" rows="3" [(ngModel)]="draft" placeholder="Pl. A kis terrárium hátfala 200 × 150 mm, a dísz legfeljebb 40 mm mélyre nyúlhat be."></textarea>
        <div class="boris-add__bar">
          <div class="boris-examples">
            <button type="button" class="boris-example" *ngFor="let ex of examples" (click)="useExample(ex)">+ {{ ex }}</button>
          </div>
          <button type="button" class="stk-btn stk-btn--accent" [disabled]="!draft.trim() || saving" (click)="add()">Jegyezd meg</button>
        </div>
      </div>

      <div class="boris-help" *ngIf="!data.knowledge.length">Még üres. Kezdd a két terrárium méreteivel és a mágnesekkel.</div>
      <div class="boris-item" *ngFor="let k of data.knowledge">
        <ng-container *ngIf="editing[k.id] === undefined; else editKnowledge">
          <div class="boris-item__text">{{ k.text }}</div>
          <div class="boris-item__meta">{{ k.createdBy || '—' }} · {{ (k.updatedAt || k.createdAt) | date:'yyyy. MMM d.' }}</div>
          <div class="boris-item__actions">
            <button type="button" class="stk-btn stk-btn--ghost boris-btn" (click)="startEdit(k)">Szerkesztés</button>
            <button type="button" class="stk-icon-btn" title="Törlés" (click)="remove(k.id)">✕</button>
          </div>
        </ng-container>
        <ng-template #editKnowledge>
          <textarea class="boris-textarea" rows="4" [(ngModel)]="editing[k.id]"></textarea>
          <div class="boris-item__actions">
            <button type="button" class="stk-btn stk-btn--accent boris-btn" [disabled]="saving || !editing[k.id].trim()" (click)="save(k.id)">Mentés</button>
            <button type="button" class="stk-btn stk-btn--ghost boris-btn" (click)="cancelEdit(k.id)">Mégse</button>
          </div>
        </ng-template>
      </div>
    </section>

    <section class="boris-card">
      <h2 class="stk-section-title">Legutóbbi munkák</h2>
      <div class="boris-help" *ngIf="!data.jobs.length">Még nem dolgozott. Írj neki a chatben!</div>
      <div class="boris-job" *ngFor="let j of data.jobs" (click)="expanded[j.id] = !expanded[j.id]">
        <div class="boris-job__top">
          <span class="boris-job__status boris-job__status--{{ j.status }}">{{ statusLabel[j.status] }}</span>
          <span class="boris-job__who">{{ j.requestedBy || 'Ismeretlen' }}</span>
          <span class="boris-job__when">{{ j.createdAt | date:'MMM d., HH:mm' }}</span>
        </div>
        <div class="boris-job__text" *ngIf="expanded[j.id] && (j.summary || j.error)">{{ j.error || j.summary }}</div>
      </div>
    </section>
  </ng-container>
</div>
